import { IApplicationState } from '../../types/redux/store';

export const selectMapBounds = (state: IApplicationState) => {
  return state.mapBounds;
};
